module.exports = __webpack_public_path__ + "static/img/iconSalim.0c9ae9f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconSalim.svg
// module id = zqcT
// module chunks = 1